var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNoFiles(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 206,
    height: 205,
    viewBox: "0 0 206 205",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_97_6356)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_97_6356)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 32.0492,
    cy: 41.5157,
    r: 1,
    stroke: "#787E8C",
    strokeOpacity: 0.5,
    strokeWidth: 1.81865
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 180.976,
    cy: 59.1768,
    r: 1,
    stroke: "#787E8C",
    strokeOpacity: 0.5,
    strokeWidth: 1.81865
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 202.456,
    cy: 68.2463,
    r: 1,
    stroke: "#787E8C",
    strokeOpacity: 0.5,
    strokeWidth: 1.81865
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 200.069,
    cy: 98.3181,
    r: 1,
    stroke: "#787E8C",
    strokeOpacity: 0.5,
    strokeWidth: 1.81865
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 100.308,
    cy: 100.347,
    rx: 68.2583,
    ry: 67.6616,
    fill: "#787E8C",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.566 100.347C167.566 137.155 137.462 167.009 100.308 167.009C63.1536 167.009 33.0493 137.155 33.0493 100.347C33.0493 63.539 63.1536 33.6853 100.308 33.6853C137.462 33.6853 167.566 63.539 167.566 100.347Z",
    stroke: "#787E8C",
    strokeOpacity: 0.8,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 9.61465,
    cy: 69.6783,
    r: 1,
    stroke: "#787E8C",
    strokeOpacity: 0.5,
    strokeWidth: 1.81865
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 61.1664,
    cy: 181.851,
    r: 1,
    stroke: "#787E8C",
    strokeOpacity: 0.5,
    strokeWidth: 1.81865
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 92.6701,
    cy: 192.83,
    r: 1,
    stroke: "#787E8C",
    strokeOpacity: 0.5,
    strokeWidth: 1.81865
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 149.95,
    cy: 179.942,
    r: 1,
    stroke: "#787E8C",
    strokeOpacity: 0.5,
    strokeWidth: 1.81865
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.3,
    cx: 123.697,
    cy: 177.078,
    r: 1.19333,
    fill: "#787E8C",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.15,
    cx: 128.47,
    cy: 190.92,
    r: 1.19333,
    fill: "#787E8C",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.3,
    cx: 109.854,
    cy: 196.648,
    r: 1.19333,
    fill: "#787E8C",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.3,
    cx: 174.294,
    cy: 166.815,
    r: 1.19333,
    fill: "#787E8C",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.3,
    cx: 189.568,
    cy: 138.414,
    r: 1.19333,
    fill: "#787E8C",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.15,
    cx: 180.26,
    cy: 123.617,
    r: 1.19333,
    fill: "#787E8C",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.3,
    cx: 184.079,
    cy: 93.5447,
    r: 1.19333,
    fill: "#787E8C",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.3,
    cx: 191.955,
    cy: 77.3156,
    r: 1.19333,
    fill: "#787E8C",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.15,
    cx: 186.466,
    cy: 40.7997,
    r: 1.19333,
    fill: "#787E8C",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.15,
    cx: 73.8156,
    cy: 199.035,
    r: 1.19333,
    fill: "#787E8C",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.3,
    cx: 39.6865,
    cy: 194.262,
    r: 1.19333,
    fill: "#787E8C",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.15,
    cx: 44.4599,
    cy: 185.908,
    r: 1.19333,
    fill: "#787E8C",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.15,
    cx: 13.4333,
    cy: 147.722,
    r: 1.19333,
    fill: "#787E8C",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.3,
    cx: 20.3545,
    cy: 132.925,
    r: 1.19333,
    fill: "#787E8C",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.15,
    cx: 2.69333,
    cy: 94.4994,
    r: 1.19333,
    fill: "#787E8C",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.3,
    cx: 21.5481,
    cy: 64.6664,
    r: 1.19333,
    fill: "#787E8C",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.15,
    cx: 25.3667,
    cy: 22.4226,
    r: 1.19333,
    fill: "#787E8C",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.3,
    cx: 61.8823,
    cy: 6.19333,
    r: 1.19333,
    fill: "#787E8C",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.15,
    cx: 108.422,
    cy: 24.8093,
    r: 1.19333,
    fill: "#787E8C",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 134.437,
    cy: 18.8425,
    r: 1.19333,
    fill: "#787E8C",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.475 150.347C169.421 150.347 168.566 149.493 168.566 148.438C168.566 147.384 169.421 146.529 170.475 146.529",
    stroke: "#787E8C",
    strokeOpacity: 0.8,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.51196 117.65C7.56645 117.65 8.42129 116.795 8.42129 115.741C8.42129 114.686 7.56645 113.831 6.51196 113.831",
    stroke: "#787E8C",
    strokeOpacity: 0.5,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.5315 22.4227C75.586 22.4227 76.4408 21.5679 76.4408 20.5134C76.4408 19.4589 75.586 18.6041 74.5315 18.6041",
    stroke: "#787E8C",
    strokeOpacity: 0.5,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.833 15.7399C119.778 15.7399 118.923 16.5948 118.923 17.6492C118.923 18.7037 119.778 19.5586 120.833 19.5586",
    stroke: "#787E8C",
    strokeOpacity: 0.5,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.3306 166.934H16.2972M26.3211 155.836V157.388M38.0157 166.934H39.5671M26.3211 176.481V178.271M26.3211 180.658V186.982M21.9058 166.934C24.8892 166.934 26.4405 162.638 26.4405 162.638C26.4405 162.638 26.9178 166.934 30.7365 166.934C29.0181 166.934 26.5598 168.486 26.3211 171.588C26.3211 171.588 26.0432 169.048 25.1278 168.128C24.3635 167.359 21.9058 166.934 21.9058 166.934Z",
    stroke: "#787E8C",
    strokeOpacity: 0.8,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.709 30.0597L172.742 30.0597M162.599 45.8116L162.718 39.6063M151.024 30.0597L149.472 30.0597M162.599 20.7517L162.599 8.57984M167.134 30.0597C164.15 30.0597 162.599 34.3557 162.599 34.3557C162.599 34.3557 162.122 30.0597 158.303 30.0597C160.021 30.0597 162.48 28.5084 162.718 25.4057C162.718 25.4057 162.996 27.9459 163.912 28.8664C164.676 29.6349 167.134 30.0597 167.134 30.0597Z",
    stroke: "#787E8C",
    strokeOpacity: 0.8,
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 76.8249,
    cy: 75.3208,
    r: 47.3208,
    fill: "white",
    stroke: "#787E8C",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 76.8249,
    cy: 75.3208,
    r: 38.9172,
    fill: "#F2F3F4",
    stroke: "#787E8C",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.2924 95.5852C70.7369 95.5852 65.5163 93.4204 61.5874 89.4975C57.6586 85.5746 55.4998 80.3481 55.4998 74.7926C55.4998 69.2372 57.6645 64.0166 61.5874 60.0877C65.5104 56.1588 70.7369 54 76.2924 54C81.8478 54 87.0684 56.1648 90.9973 60.0877C94.9262 64.0106 97.085 69.2372 97.085 74.7926C97.085 80.3481 94.9202 85.5686 90.9973 89.4975C87.0744 93.4264 81.8478 95.5852 76.2924 95.5852ZM76.2924 54.2392C70.8027 54.2392 65.6419 56.3801 61.7609 60.2611C57.8798 64.1422 55.739 69.3029 55.739 74.7926C55.739 80.2823 57.8798 85.4431 61.7609 89.3241C65.6419 93.2052 70.8027 95.346 76.2924 95.346C81.7821 95.346 86.9428 93.2052 90.8239 89.3241C94.7049 85.4431 96.8458 80.2823 96.8458 74.7926C96.8458 69.3029 94.7049 64.1422 90.8239 60.2611C86.9428 56.3801 81.7821 54.2392 76.2924 54.2392Z",
    fill: "#194590"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.2924 90.1134C72.2021 90.1134 68.3569 88.5227 65.4626 85.6284C62.5682 82.7341 60.9775 78.8889 60.9775 74.7985C60.9775 70.7082 62.5682 66.863 65.4626 63.9687C68.3569 61.0743 72.2021 59.4836 76.2924 59.4836C80.3828 59.4836 84.2279 61.0743 87.1223 63.9687C90.0166 66.863 91.6073 70.7082 91.6073 74.7985C91.6073 78.8889 90.0166 82.7341 87.1223 85.6284C84.2279 88.5227 80.3828 90.1134 76.2924 90.1134ZM76.2924 59.7109C72.2619 59.7109 68.4765 61.2777 65.63 64.1301C62.7835 66.9766 61.2108 70.762 61.2108 74.7926C61.2108 78.8231 62.7775 82.6085 65.63 85.455C68.4765 88.3015 72.2619 89.8742 76.2924 89.8742C80.323 89.8742 84.1083 88.3075 86.9548 85.455C89.8013 82.6085 91.3741 78.8231 91.3741 74.7926C91.3741 70.762 89.8073 66.9766 86.9548 64.1301C84.1083 61.2836 80.323 59.7109 76.2924 59.7109Z",
    fill: "#194590",
    stroke: "#194590"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.2917 80.7312C73.0146 80.7312 70.3535 78.0701 70.3535 74.793C70.3535 71.5159 73.0146 68.8548 76.2917 68.8548C79.5688 68.8548 82.2299 71.5159 82.2299 74.793C82.2299 78.0701 79.5688 80.7312 76.2917 80.7312ZM76.2917 69.094C73.1522 69.094 70.5927 71.6535 70.5927 74.793C70.5927 77.9325 73.1522 80.492 76.2917 80.492C79.4312 80.492 81.9907 77.9325 81.9907 74.793C81.9907 71.6535 79.4312 69.094 76.2917 69.094Z",
    fill: "#194590",
    stroke: "#194590"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M85.4782 78.5184C90.8219 78.5184 95.1539 74.1864 95.1539 68.8427C95.1539 63.4989 90.8219 59.1669 85.4782 59.1669C80.1345 59.1669 75.8025 63.4989 75.8025 68.8427C75.8025 74.1864 80.1345 78.5184 85.4782 78.5184Z",
    fill: "#194590"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.2924 95.5852C70.7369 95.5852 65.5163 93.4204 61.5874 89.4975C57.6586 85.5746 55.4998 80.3481 55.4998 74.7926C55.4998 69.2372 57.6645 64.0166 61.5874 60.0877C65.5104 56.1588 70.7369 54 76.2924 54C81.8478 54 87.0684 56.1648 90.9973 60.0877C94.9262 64.0106 97.085 69.2372 97.085 74.7926C97.085 80.3481 94.9202 85.5686 90.9973 89.4975C87.0744 93.4264 81.8478 95.5852 76.2924 95.5852ZM76.2924 54.2392C70.8027 54.2392 65.6419 56.3801 61.7609 60.2611C57.8798 64.1422 55.739 69.3029 55.739 74.7926C55.739 80.2823 57.8798 85.4431 61.7609 89.3241C65.6419 93.2052 70.8027 95.346 76.2924 95.346C81.7821 95.346 86.9428 93.2052 90.8239 89.3241C94.7049 85.4431 96.8458 80.2823 96.8458 74.7926C96.8458 69.3029 94.7049 64.1422 90.8239 60.2611C86.9428 56.3801 81.7821 54.2392 76.2924 54.2392Z",
    fill: "#194590",
    stroke: "#194590"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M59.2847 76.0008C58.0408 76.0008 56.8388 76.1682 55.6907 76.4792C55.7864 77.6334 55.9717 78.7576 56.2468 79.852C57.2036 79.553 58.2262 79.3915 59.2847 79.3915C64.9179 79.3915 69.4866 83.9602 69.4866 89.5934C69.4866 91.1483 69.1398 92.6253 68.5119 93.9469C69.5584 94.3715 70.6527 94.7183 71.777 94.9695C72.4886 93.319 72.8833 91.5071 72.8833 89.5994C72.8773 82.0885 66.7896 76.0008 59.2847 76.0008Z",
    fill: "#194590"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.4399 60.7219C89.9987 59.173 88.3302 57.8455 86.4764 56.799C87.6126 57.9591 88.3183 59.5438 88.3183 61.296C88.3183 64.8421 85.4479 67.7125 81.9017 67.7125C78.3555 67.7125 75.4851 64.8421 75.4851 61.296C75.4851 57.7618 78.3376 54.8973 81.8658 54.8794C80.0957 54.383 78.224 54.1199 76.2984 54.1199C76.0592 54.1199 75.82 54.1259 75.5808 54.1319C73.6014 55.884 72.3516 58.4435 72.3516 61.296C72.3516 66.5763 76.6273 70.8521 81.9077 70.8521C87.1881 70.8521 91.4638 66.5763 91.4638 61.296C91.4578 61.1046 91.4458 60.9132 91.4399 60.7219Z",
    fill: "#194590"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 112.976,
    y: 126.82,
    width: 21.5508,
    height: 49.407,
    rx: 4,
    transform: "rotate(-44.8121 112.976 126.82)",
    fill: "white",
    stroke: "#787E8C",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.537 112.437L116.742 123.641",
    stroke: "#787E8C",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.941 104.033L125.146 115.238",
    stroke: "#787E8C",
    strokeWidth: 2
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_97_6356"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 205,
    height: 205,
    fill: "white",
    transform: "translate(0.5)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_97_6356"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 205,
    height: 205,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoFiles);
export default __webpack_public_path__ + "static/media/no-files.ce464b619452bf7053c740d71364e7f7.svg";
export { ForwardRef as ReactComponent };